/**
 * api接口的统一出口
 */
// login模块接口

import account from '@/network/account';
import user from '@/network/user';
import dashboard from "@/network/dashboard";
import shop from '@/network/shop'


import auth from '@/network/auth';
import upload from '@/network/file'
import models from '@/network/models'

// 其他模块的接口……

// 导出接口
export default {
    auth,
    account,
    user,
    dashboard,
    shop,
    upload,
    models
}
